import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";
import { AISummary, AISummaryStatus } from "@/shared/domain/ai_summary";

export function useDatasetSummary(
  datasetId: string,
  options?: {
    pendingPollRateMs?: number;
  },
): UseQueryResult<AISummary, Error> {
  const { datasetService } = useDomainServices();

  return useQuery({
    queryKey: ["dataset-summary", datasetId],
    queryFn: ({ signal }) => {
      return datasetService.getSummary(datasetId, {
        abortSignal: signal,
      });
    },
    staleTime: 300 * 1000, // 5 minutes in seconds
    refetchInterval: (query) => {
      const data = query.state.data;
      const pendingPollRateMs = options?.pendingPollRateMs ?? 2000; // Explicit polling rate or 2 seconds
      return data?.status === AISummaryStatus.Pending
        ? pendingPollRateMs
        : false;
    },
  });
}
